import { CurrentUserActionType } from '../../types/currentUserType'

export const setUpCurrentUser = (data : any) => {
    return {type: CurrentUserActionType.SET_UP_CURRENT_USER, payload: data}
}